import type { NotificationChannel } from "../shared/communications-types";

/**
 * Filters for `GET /api/admin/communications`. All optional; the backend
 * treats `key` as a substring match, `channel` / `locale` as exact.
 */
export interface CommunicationsFilters {
  readonly key?: string;
  readonly channel?: NotificationChannel;
  readonly locale?: string;
}

/**
 * Serialise filters into a query string, omitting empty values so the
 * cache key (and the URL) stays stable when a filter is cleared. Returns
 * the leading `?` when non-empty, or `""` when all filters are empty.
 */
export function buildCommunicationsQuery(filters: CommunicationsFilters): string {
  const params = new URLSearchParams();
  const key = filters.key?.trim();
  if (key) params.set("key", key);
  if (filters.channel) params.set("channel", filters.channel);
  const locale = filters.locale?.trim();
  if (locale) params.set("locale", locale);
  const query = params.toString();
  return query ? `?${query}` : "";
}
